export default __webpack_public_path__ + "assets/img-action-greeting-della-avatar2-80db7ced.png";